import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

// Definitions (Master Checklist)
async function getDefinitions(params?: any) {
  const response = await http
    .getDataParam("/gizi/supervisi/definitions", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Sessions (Supervisi)
async function getList(params?: any) {
  const response = await http
    .getDataParam("/gizi/supervisi/sessions", params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/gizi/supervisi/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/gizi/supervisi/sessions", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/gizi/supervisi/sessions/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/gizi/supervisi/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Submit & Save final items
async function submit(id: number, data: any) {
  const response = await http
    .postData(`/gizi/supervisi/sessions/${id}/submit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Signing
async function signSupervisor(id: number, data: { password: string }) {
  const response = await http
    .postData(`/gizi/supervisi/sessions/${id}/sign-supervisor`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function acknowledge(id: number, data: { password: string }) {
  const response = await http
    .postData(`/gizi/supervisi/sessions/${id}/acknowledge`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Tindak Lanjut
async function updateTindakLanjut(sessionId: number, itemId: number, data: any) {
  const response = await http
    .putData(`/gizi/supervisi/sessions/${sessionId}/items/${itemId}/tindak-lanjut`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getTemuanTerbuka(params?: any) {
  const response = await http
    .getDataParam("/gizi/supervisi/temuan-terbuka", params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Dashboard
async function getDashboard(params?: any) {
  const response = await http
    .getDataParam("/gizi/supervisi/dashboard", params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// PDF
function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/gizi/supervisi/sessions/${id}/pdf`,
    "_blank"
  );
}

export default {
  getDefinitions,
  getList,
  find,
  create,
  update,
  destroy,
  submit,
  signSupervisor,
  acknowledge,
  updateTindakLanjut,
  getTemuanTerbuka,
  getDashboard,
  printPdf,
};
